import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useSystemSettings } from '@/hooks/useSystemSettings';

export const AuthButtons: React.FC = () => {
  const { allowSignups } = useSystemSettings();

  return (
    <div className="flex items-center space-x-2 ml-4">
      <Link to="/login">
        <Button variant="outline">Log in</Button>
      </Link>
      {allowSignups && (
        <Link to="/signup">
          <Button>Get Started</Button>
        </Link>
      )}
    </div>
  );
};
